var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCodeEditorNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.40002 18C1.02872 18 0.672585 17.8525 0.410034 17.59C0.147483 17.3274 0 16.9713 0 16.6V1.39701C0 1.0257 0.147483 0.66961 0.410034 0.407059C0.672585 0.144508 1.02872 -0.00299072 1.40002 -0.00299072H22.612C22.9823 -0.00140387 23.3368 0.146797 23.5981 0.409176C23.8593 0.671555 24.006 1.02674 24.006 1.39701V16.604C24.0044 16.9732 23.857 17.3269 23.5959 17.588C23.3349 17.8491 22.9812 17.9964 22.612 17.998L1.40002 18ZM1.54797 16.458H22.464V1.54701H1.54797V16.458ZM9.85498 13.939L12.614 3.63901L14.152 4.05101L11.393 14.351L9.85498 13.939ZM14.882 11.788L17.668 8.99601L14.882 6.20601L16 5.08101L19.913 8.99401L16 12.909L14.882 11.788ZM4.099 8.99401L8.01202 5.08101L9.13501 6.20401L6.349 8.99401L9.13501 11.786L8.01202 12.909L4.099 8.99401Z",
    fill: "#203662"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeEditorNewIcon);
export default __webpack_public_path__ + "static/media/Code-Editor-New-Icon.bfbae6ef28a081eeb84de930b36b1730.svg";
export { ForwardRef as ReactComponent };